<template>
<table
  class="sheet-table table-striped"
  v-if="modules && moduleColumns"
  :key="pipeLine"
  ref="pricingTable"
>
  <PricingSheetHead @updated="updated" @editElement="editElement"></PricingSheetHead>
  <PricingSheetBody
    v-for="(module, key) in modules"
    :key="key"
    :module="module"
    :ref="'module'+key"
    :moduleKey="key"
    :isDragEnded="isDragEnded"
    v-if="!module.hidden"
    :dragStartedKey="dragStartedKey"
    :dragModuleStartedKey="dragModuleStartedKey"
    @dragComStarted="dragStarted"
    @dragComOvered="dragOvered"
    @dragComEnded="dragEnded"
    @dragModuleStarted="dragModuleStarted"
    @dragModuleEnded="dragModuleEnded"
    @dragModuleOvered="dragModuleOvered"
    @previewImage="previewImage($event)"
  >
  </PricingSheetBody>
  <tbody>
    <tr v-if="editable">
      <td
        class="blue-dark-bar"
        :colspan="totalColumns"
      >
        <img :src="staticImgPath + 'Add-New-Group-Icon.png'" @click="addModule($event)" class="add-new-module-plus curp"/>
        <span @click="addModule($event)" class="curp">
          New Group
        </span>
      </td>
    </tr>
    <tr><td class="bottom-extra" :colspan="totalColumns"></td></tr>
    <tr><td class="bottom-extra" :colspan="totalColumns"></td></tr>
    <tr><td class="bottom-extra" :colspan="totalColumns"></td></tr>
  </tbody>
  <div
    class="task-wrapper project-pricing-modal"
    @click="closeTaskCard()"
    v-if="editTask"
  >
    <div class="task-modal">
      <ProjectTask
        :taskType="editTask.type"
        :taskIndex="editTask.index"
        @deletedTaskForProjectCard="closeTaskCard"
        @closeTaskCard="closeTaskCard"
        @openNewCard="openNewCard"
      />
    </div>
  </div>
  <div v-if="isPreviewImage" class="preview-image-wrapper" @click="closePreview()">
    <div class="box image-preview-box df fdc jcsb">
      <div class="preview-title">
        <div></div>
        <h2 class="jsc tac">{{taskName}}</h2>
        <div class="close-attachment">
          <img :src="staticImgPath + 'CloseIcon.png'"alt="">
        </div>
      </div>
      <div class="df jcc preview-image-wrapper-inner">
        <img :src="previewImageUrl" class="previewedImage"/>
      </div>
    </div>
  </div>
</table>
</template>

<script>
import PricingSheetHead from './PricingSheet/PricingSheetHead'
import PricingSheetBody from './PricingSheet/PricingSheetBody'
import ProjectTask from '../ProjectTask'

import { EventBus } from '../../../event-bus';
import { mapGetters } from 'vuex';

export default {
  name: 'ProjectPagePricing',
  data () {
    return {
      staticImgPath: "/images/",
      editTask: null,
      pipeLine: -1,
      isDragEnded: false,
      dragStartedKey: {},
      dragOveredKey: {},
      dragModuleOveredKey: null,
      dragModuleStartedKey: null,
      isPreviewImage: false,
      previewImageUrl: '',
      taskName: '',
      scrollTopBeforePreview: 0
    }
  },
  props: [],
  components: {
    PricingSheetHead,
    PricingSheetBody,
    ProjectTask
  },
  methods: {
    editElement(data) {
      this.editTask = data
    },
    closeTaskCard() {
      this.editTask = null
    },
    deletedTaskForProjectCard(){
      this.editTask = null
    },
    openNewCard(type, index){
      this.editTask = { type, index }
    },
    addHourlyColumnAndEdit() {
      this.$store.dispatch('addHourlyColumn', {
          phases: this.currentProjectPhases,
          projectid: this.projectId
      }).then(() => {
        this.editTask = {
          type: 'hourlyElements',
          index: this.moduleColumns.hourlyElements.length-1
        }
      })
    },
    addModule() {
      this.$store.dispatch('addNewModule', { projectid: this.projectId })
    },
    updated() {
      this.pipeLine++;
    },
    dragStarted(moduleKey, comKey) {
      this.isDragEnded = false
      this.dragStartedKey = { moduleKey, comKey }
    },
    dragOvered(moduleKey, comKey) {
      this.dragOveredKey = { moduleKey, comKey }
    },
    dragEnded(moduleKey, comKey) {
      this.isDragEnded = true
      this.$store.dispatch('moveComponentRow', {
        projectid: this.$route.params.projectid,
        a: moduleKey,
        b: comKey,
        c: this.dragOveredKey.moduleKey,
        d: this.dragOveredKey.comKey
      }).then(() => {
        this.pipeLine++;
      })
    },
    dragModuleStarted(moduleKey) {
      this.dragModuleStartedKey = moduleKey
    },
    dragModuleEnded(moduleKey) {
      if (this.dragModuleOveredKey !== null && this.dragModuleOveredKey !== moduleKey) {
        const data = {
          a: moduleKey,
          b: this.dragModuleOveredKey,
          projectid: this.$route.params.projectid
        }
        this.$store.dispatch('swapModules', data).then(() => {
          this.pipeLine++;
        })
      }
    },
    dragModuleOvered(moduleKey) {
      this.dragModuleOveredKey = moduleKey
    },
    previewImage(res) {
      this.previewImageUrl = res.url
      this.taskName = res.name
      this.isPreviewImage = true
    },
    closePreview() {
      this.isPreviewImage = false
    }
  },
  computed: {
    ...mapGetters(['currentProjectPhases', 'editingCell', 'userRole']),
    moduleColumns() {
      return this.$store.getters.currentProjectModuleColumns
    },
    modules() {
      return this.$store.getters.currentProjectModules
    },
    projectId() {
      return this.$route.params.projectid
    },
    totalColumns() {
      if (this.moduleColumns) {
        let count = !!this.moduleColumns.metaElements && this.moduleColumns.metaElements.length
          count += this.moduleColumns.fixedElements ? this.moduleColumns.fixedElements.length : 0
          count += this.moduleColumns.hourlyElements ? this.moduleColumns.hourlyElements.filter(el => !el.hidden).length : 0
          count += this.moduleColumns.percentTasks ? this.moduleColumns.percentTasks.filter(el => !el.hidden).length : 0
        return count + 2;
      }
      return 0;
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  created () {
    document.onkeydown = checkKey;
    var _this = this;
    EventBus.$on('addAndEditNewResource', () => {
      _this.addHourlyColumnAndEdit();
    });
    async function checkKey(e) {
      if (_this.editingCell) {
        return;
      }
      if (e.keyCode === 37) { // arrow left
        if (e.ctrlKey || e.metaKey) {
          _this.$store.dispatch('ctrlKeyLeftCell');
        } else {
          _this.$store.dispatch('keyLeftCell');
        }
      } else if (e.keyCode === 38) { // arrow up
        if (e.ctrlKey || e.metaKey) {
          _this.$store.dispatch('ctrlKeyUpCell');
        } else {
          _this.$store.dispatch('keyUpCell');
        }
      } else if (e.keyCode === 39) { // arrow right
        if (e.ctrlKey || e.metaKey) {
          _this.$store.dispatch('ctrlKeyRightCell');
        } else {
          _this.$store.dispatch('keyRightCell');
        }
      } else if (e.keyCode === 40) { // arrow down
        if (e.ctrlKey || e.metaKey) {
          _this.$store.dispatch('ctrlKeyDownCell');
        } else {
          _this.$store.dispatch('keyDownCell');
        }
      }
      if ((e.ctrlKey || e.metaKey) && e.keyCode === 90) {
        if (e.shiftKey) {
          _this.$store.dispatch("redoAction", { projectid: _this.$route.params.projectid })
        } else {
          _this.$store.dispatch("undoAction", { projectid: _this.$route.params.projectid })
        }
      }
    }
  },
  updated () {
  },
  beforeDestroy() {
    EventBus.$off('addAndEditNewResource');
  },
  destroyed () {}
}
</script>

<style scoped lang="scss">
@import "../../../styles/components/_pricingsheet.scss";
</style>
